import * as React from 'react'
import { Section } from '../section'
import { styles } from './styles.css'
import { Flex } from '@radix-ui/themes'
import cool from './images/cool.svg'
import caret from './images/caret.svg'

export const PlanSection: React.FC = () => {
  return (
    <Section id="plan" title="PLAN" subtitle="お届け内容・料金" className={styles.section}>
      <Flex direction="column" gap="24px" px="24px">
        <div className={styles.card}>
          <Flex direction="column" gap="16px" p="24px">
            <Flex direction="column" align="center">
              <Flex direction="row" align="center" gap="16px">
                <span className={styles.planLabel}>月額</span>
                <span className={styles.planPrice}>
                  2,970<span style={{ fontSize: "18px", marginLeft: "2px" }}>円</span>
                  <span style={{ fontSize: "12px" }}>（送料無料）</span>
                </span>
              </Flex>
              <p className={styles.planDelivery}>配送ごとにお支払い・いつでも解約可能</p>
            </Flex>
            <hr className={styles.divider} />
            <Flex direction="column" gap="8px">
              <dl>
                <Flex direction="row" align="center" gap="8px" mb="8px">
                  <dt className={styles.planKey}>お届け頻度</dt>
                  <dd className={styles.planValue}>月に1回</dd>
                </Flex>
                <Flex direction="row" align="center" gap="8px">
                  <dt className={styles.planKey}>ブーケのサイズ</dt>
                  <dd className={styles.planValue}>長さ約42cm 12本入り</dd>
                </Flex>
              </dl>
              <Flex direction="row" gap="4px" align="center" className={styles.note}>
                <img src={cool} className={styles.cool} />
                夏期はクール便でお届け（追加料金なし）
              </Flex>
            </Flex>
          </Flex>
        </div>
        <details className={styles.card}>
          <summary className={styles.summary}>
            <span>もし枯れてたら？安心の品質補償</span>
            <img src={caret} className={styles.caret} />
          </summary>
          <div className={styles.cardContent}>
            <hr className={styles.divider} />
            <p className={styles.text}>
              もしお花が「枯れている」「折れている」などの不備がございましたら、返金もしくは代品にて補償が可能です。お気軽にサポートまでお問い合わせください💁‍♀️
            </p>
          </div>
        </details>
        <details className={styles.card}>
          <summary className={styles.summary}>
            <span>不在時はお届けをスキップできる</span>
            <img src={caret} className={styles.caret} />
          </summary>
          <div className={styles.cardContent}>
            <hr className={styles.divider} />
            <p className={styles.text}>旅行や長期不在のときは、スキップが可能です。次回発送の3日前の正午までにお手続きいただければOKです🙆‍♀️</p>
          </div>
        </details>
        <details className={styles.card}>
          <summary className={styles.summary}>
            <span>違約金なし！いつでも解約OK</span>
            <img src={caret} className={styles.caret} />
          </summary>
          <div className={styles.cardContent}>
            <hr className={styles.divider} />
            <p className={styles.text}>
              FLOWERの定期便は、いつでもスキップ・解約が可能です。次回発送の3日前の正午までにお手続きいただければOKです。まずは気軽に始めてみてください☺️
            </p>
          </div>
        </details>
      </Flex>
    </Section>
  )
}
